import React, { useState } from 'react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '@cargomatic/ui';
import { columnCategoriesMap } from './categories';
import { useTranslation } from 'react-i18next';
const ALL = 'all';
const billingColumnGroups = ['billing_status', 'billing_status_state'];
function getFinanceAndBillingColumns(colDefs) {
    return [
        ...colDefs.filter((col) => billingColumnGroups.includes(col.groupId)),
        ...colDefs.filter((col) => columnCategoriesMap.finance_and_billing.columns.includes(col.colId)),
    ];
}
function getReferenceNumberAndNotesColumns(colDefs) {
    return [
        ...colDefs.filter((col) => col.groupId === 'standard_reference_numbers'),
        ...colDefs.filter((col) => columnCategoriesMap.reference_and_notes.columns.includes(col.colId)),
    ];
}
const basicStopColumnGroups = [
    'loaded_pickup_stops',
    'loaded_delivery_stops',
    'empty_delivery_stops',
    'empty_pickup_stops',
];
const stopColumnsGroups = [
    ...basicStopColumnGroups,
    'offsite_loaded_pickup_stops',
    'offsite_loaded_delivery_stops',
    'offsite_empty_delivery_stops',
    'offsite_empty_pickup_stops',
];
const basicStopColumns = [
    'stop_sequence',
    'stop_address',
    'stop_window_start',
    'stop_status',
    'stop_completed_date',
];
function getBasicStopsInfoColumns(colDefs) {
    const groups = colDefs.filter((colDef) => basicStopColumnGroups.includes(colDef.groupId));
    const basicStopsInfoColumns = groups.map((group) => {
        const children = group.children
            .filter((_, i) => i === 0)
            .map((subGroup) => {
            const columns = basicStopColumns.map((colId) => `${subGroup.groupId}__${colId}`);
            return Object.assign(Object.assign({}, subGroup), { children: subGroup.children.filter((col) => columns.includes(col.colId)) });
        });
        return Object.assign(Object.assign({}, group), { children });
    }, []);
    return basicStopsInfoColumns;
}
function getStopDetailColumns(colDefs) {
    return colDefs.filter((colDef) => stopColumnsGroups.includes(colDef.groupId));
}
export function ColumnCategoriesDropdown({ api }) {
    const { t } = useTranslation();
    const [selectedCategory, setSelectedCategory] = useState(ALL);
    function handleSelect(category) {
        var _a, _b;
        api === null || api === void 0 ? void 0 : api.openToolPanel('columns');
        setSelectedCategory(category);
        const columnsPanel = api === null || api === void 0 ? void 0 : api.getToolPanelInstance('columns');
        if (!columnsPanel) {
            return;
        }
        const allColumns = api === null || api === void 0 ? void 0 : api.getColumnDefs();
        if (!category || category === ALL) {
            columnsPanel.setColumnLayout(allColumns);
            return;
        }
        if (category === 'finance_and_billing') {
            columnsPanel.setColumnLayout(getFinanceAndBillingColumns(allColumns));
            return;
        }
        if (category === 'reference_and_notes') {
            columnsPanel.setColumnLayout(getReferenceNumberAndNotesColumns(allColumns));
            return;
        }
        if (category === 'stop_details') {
            columnsPanel.setColumnLayout(getStopDetailColumns(allColumns));
            return;
        }
        if (category === 'basic_stops_info') {
            columnsPanel.setColumnLayout(getBasicStopsInfoColumns(allColumns));
            return;
        }
        const columnsInSelectedCategory = (_b = (_a = columnCategoriesMap[category]) === null || _a === void 0 ? void 0 : _a.columns) !== null && _b !== void 0 ? _b : [];
        if (columnsInSelectedCategory.length > 0) {
            columnsPanel.setColumnLayout(allColumns.filter((col) => {
                return columnsInSelectedCategory.includes(col.field);
            }));
        }
        else {
            columnsPanel.setColumnLayout(allColumns.filter((col) => !(col.hide === true && !col.groupId)));
        }
    }
    return (React.createElement(Select, { value: selectedCategory, onValueChange: handleSelect },
        React.createElement(SelectTrigger, { className: "w-[180px]" },
            React.createElement(SelectValue, { placeholder: "Select a category" })),
        React.createElement(SelectContent, null,
            React.createElement(SelectGroup, null,
                React.createElement(SelectLabel, null, t('COLUMN_CATEGORIES')),
                React.createElement(SelectItem, { value: "all" }, "All"),
                React.createElement(SelectItem, { value: "visible" }, t('VISIBLE_COLUMNS')),
                React.createElement(SelectItem, { value: "basic_shipment_info" }, t('BASIC_SHIPMENT_INFO')),
                React.createElement(SelectItem, { value: "shipment_details" }, t('SHIPMENT_DETAILS')),
                React.createElement(SelectItem, { value: "basic_stops_info" }, t('BASIC_STOPS_INFO')),
                React.createElement(SelectItem, { value: "stop_details" }, t('STOP_DETAILS')),
                React.createElement(SelectItem, { value: "dates_and_milestones" }, t('DATES_AND_MILESTONES')),
                React.createElement(SelectItem, { value: "finance_and_billing" }, t('FINANCE_AND_BILLING')),
                React.createElement(SelectItem, { value: "charges_and_accessorials" }, t('CHARGES_AND_ACCESSORIALS')),
                React.createElement(SelectItem, { value: "ocean_tracking" }, t('OCEAN_TRACKING')),
                React.createElement(SelectItem, { value: "rail_tracking" },
                    t('RAIL_TRACKING'),
                    " "),
                React.createElement(SelectItem, { value: "documents" }, t('DOCUMENTS')),
                React.createElement(SelectItem, { value: "reference_and_notes" }, t('REFERENCE_AND_NOTES')),
                React.createElement(SelectItem, { value: "team" }, t('TEAM'))))));
}
